import { render } from "./Linkaccount.vue?vue&type=template&id=8a087ebc"
import script from "./Linkaccount.vue?vue&type=script&lang=js"
export * from "./Linkaccount.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__